<template>
<div class="center grid">
  <vs-row>
    <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
      <i class="dot"></i> 기본정보
    </vs-col>
  </vs-row>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">회사명</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_1}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_1" :readonly="true"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">소속</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_5}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_5" :readonly="true"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">부서</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_2}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_2" :readonly="true"/>
    </div>

  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">작성자</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_4}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_4" :readonly="true"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">작성일</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_3}} </span>
      <date-selector v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">안전관리책임자
        (해역본부장)</div>
        <span v-if="isPrint" class="print-input"> {{form.inputA_6}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_6" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">주관부서 담당자</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_7}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_7" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">안전보건부서장</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_8}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_8" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">안전보건관리책임자
        (이사장)</div>
      <span v-if="isPrint" class="print-input"> {{form.inputA_9}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_9" :readonly="board.readonly"/>
    </div>
  </div>
  <vs-row style="padding-top: 1rem;">
    <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
      <i class="dot"></i> 사고조사 내용
    </vs-col>
  </vs-row>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">소속</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_1}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_1" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">직책</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_2}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_2" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">성명</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_3}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_3" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">일시</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_4}} </span>
      <date-selector v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">장소</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_5}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_5" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">재해형태</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_6}} </span>
      <disaster-class-selector
        v-else
        class="w-full flex-1"
        v-model="form.inputB_6"
        :readonly="board.readonly"
      />
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-center">
      <div class="label-text mr-4">제목</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_7}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_7" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">사고내용</div>
      <span v-if="isPrint" class="print-textarea"> {{form.inputB_8}} </span>
      <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_8" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">발생경위</div>
      <span v-if="isPrint" class="print-textarea"> {{form.inputB_9}} </span>
      <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_9" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">피해정도</div>
      <span v-if="isPrint" class="print-textarea"> {{form.inputB_10}} </span>
      <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_10" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">특이사항</div>
      <span v-if="isPrint" class="print-textarea"> {{form.inputB_11}} </span>
      <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_11" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">동종사고 전례</div>
      <span v-if="isPrint" class="print-textarea"> {{form.inputB_12}} </span>
      <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_12" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">목격자 성명</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_13}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_13" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">직책</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_14}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_14" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">부서명</div>
      <span v-if="isPrint" class="print-input"> {{form.inputB_15}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputB_15" :readonly="board.readonly"/>
    </div>
  </div>
  <file-upload-module
    v-if="!isPrint"
    class="w-full mt-4"
    :isPrint="isPrint"
    :readonly="board.readonly"
    v-model="form.fileList"/>
</div>
</template>

<script>
import DateSelector from '@/components/selector/DateSelector'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector.vue'
export default {
  name: 'Write',
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data () {
    return {
      form: {
        inputA_1:'',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputA_7: '',
        inputA_8: '',
        inputA_9: '',
        inputB_1:'',
        inputB_2:'',
        inputB_3:'',
        inputB_4:'',
        inputB_5:'',
        inputB_6:'',
        inputB_7:'',
        inputB_8:'',
        inputB_9:'',
        inputB_10:'',
        inputB_11:'',
        inputB_12:'',
        inputB_13:'',
        inputB_14:'',
        inputB_15:'',
        fileList: [],
      }
    }
  },
  components: {
    DateSelector,
    FileUploadModule,
    DisasterClassSelector
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.writer.section
        this.form.inputA_4 = this.value && this.value.inputA_4 ? this.value.inputA_4 : this.board.writer.name
        this.form.inputA_5 = this.value && this.value.inputA_5 ? this.value.inputA_5 : this.board.writer.department
      }
    },
    value (value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_1
        value.summary = [value.inputA_5]
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
  .label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
  }
  .grid {
    padding-top: 1rem;
  }
</style>
